import { render, staticRenderFns } from "./buy-order-code.vue?vue&type=template&id=6965f2ac&scoped=true"
import script from "./buy-order-code.vue?vue&type=script&lang=js"
export * from "./buy-order-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6965f2ac",
  null
  
)

export default component.exports